import saga from 'Modules/userList/store/saga'
import reducer from 'Modules/userList/store/reducer'
import { makeSelectUserList } from 'Modules/userList/store/selectors'
import { useDispatch, useSelector } from 'react-redux'
import {
  blockOrActiveUser,
  getAllPortfolioByUserId,
  getInfoUserAndPortfolio,
  getUserList } from 'Modules/userList/store/actions'
import { useInjectReducer, useInjectSaga } from 'Stores'

export const useUserList = () => {
  useInjectSaga({ key: 'userList', saga })
  useInjectReducer({ key: 'userList', reducer })

  const {
    total,
    pagination,
    info,
    portfolios,
    users,
    filter
  } = useSelector(
    makeSelectUserList()
  )

  const dispatch = useDispatch()

  const getUserListAction = (payload) => dispatch(getUserList(payload))
  const blockOrActiveUserAction = (payload) => dispatch(blockOrActiveUser(payload))
  const getAllPortfolioByUserIdAction = (payload) => dispatch(getAllPortfolioByUserId(payload))
  const getInfoUserAndPortfolioAction = (payload) => dispatch(getInfoUserAndPortfolio(payload))

  return {
    total,
    pagination,
    info,
    portfolios,
    users,
    filter,
    getUserListAction,
    blockOrActiveUserAction,
    getAllPortfolioByUserIdAction,
    getInfoUserAndPortfolioAction
  }
}
